// @ts-nocheck

import * as Bouncer from 'formbouncerjs'
import AOS from 'aos';
import 'aos/dist/aos.css';

const emails = ['temp-mail.org', 'correotemporal.org', 'mohmal.com', 'yopmail.com', 'tempail.com', 'emailondeck.com', 'emailtemporalgratis.com', 'crazymailing.com', 'tempr.email', 'bupmail.com', 'guerrillamail.com', 'temp-mail.io', 'es.emailfake.com', 'nowmymail.com', '10minutemail.net', 'es.getairmail.com', 'mailf5.com', 'flashmail.it', '10minemail.com', 'mailcatch.com', 'temp-mails.com', 'spambox.us', 'mailnull.com', 'incognitomail.com', 'ssl.trashmail.net', 'trashmail.net', 'mailinator.com', 'tempinbox.com', 'filzmail.com', 'dropmail.me', 'spam4.me', 'cs.email', 'one-off.email', 'throwawaymail.com', 'emailtemporal.org', 'maildrop.cc', 'mailforspam.com', 'trashmail.com', 'teleworm.us', 'superrito.com', 'rhyta.com', 'jourrapide.com', 'gustr.com', 'fleckens.hu', 'einrot.com', 'cuvox.de', 'dayrep.com', 'muyoc.com', 'buxod.com', 'pidox.org', 'mecip.net', 'pudxe.com', 'xedmi.com', 'ludxc.com', 'juzab.com', 'klepf.com', 'matra.site', 'bombamail.icu', 'yermail.net', 'totallynotfake.net', 'techblast.ch', 'spamthis.network', 'spammy.host', 'spammer.fail', 'shadap.org', 'pewpewpewpew.pw', 'netcom.ws', 'itcompu.com', 'disposable.site', 'deinbox.com', 'sharklasers.com', 'guerrillamailblock.com', 'guerrillamail.org', 'guerrillamail.net', 'guerrillamail.de', 'guerrillamail.biz', 'grr.la', 'netmail.tk', 'laste.ml', 'firste.ml', 'zeroe.ml', 'supere.ml', 'emlhub.com', 'emlpro.com', 'emltmp.com', 'yomail.info', '10mail.org', 'wegwerfmail.org', 'wegwerfmail.net', 'wegwerfmail.de', 'trashmail.me', 'trashmail.io', 'trashmail.at', 'trash-mail.at', 'rcpt.at', 'proxymail.eu', 'objectmail.com', 'kurzepost.de', 'damnthespam.com', 'contbay.com', '0box.eu', 'marmaryta.space', '5y5u.com', '58as.com', 'firemailbox.club', 'mozej.com', 'mailna.co', 'mailna.in', 'mailna.me', 'mohmal.im', 'mohmal.in', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf', 'nospam.ze.tc', 'nomail.xl.cx', 'mega.zik.dj', 'speed.1s.fr', 'courriel.fr.nf', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'nedoz.com', 'nmagazinec.com', 'armyspy.com', 'vmani.com', 'discard.email', 'discardmail.com', 'discardmail.de', 'spambog.com', 'spambog.de', 'spambog.ru', '0btcmail.pw', '815.ru', 'knol-power.nl', 'hartbot.de', 'freundin.ru', 'smashmail.de', 's0ny.net', 'pecinan.net', 'budaya-tionghoa.com', 'lajoska.pe.hu', '1mail.x24hr.com', 'from.onmypc.info', 'now.mefound.com', 'mowgli.jungleheart.com', 'yourspamgoesto.space', 'pecinan.org', 'budayationghoa.com', 'CR.cloudns.asia', 'TLS.cloudns.asia', 'MSFT.cloudns.asia', 'B.cr.cloUdnS.asia', 'ssl.tls.cloudns.ASIA', 'sweetxxx.de', 'DVD.dns-cloud.net', 'DVD.dnsabr.com', 'BD.dns-cloud.net', 'YX.dns-cloud.net', 'SHIT.dns-cloud.net', 'SHIT.dnsabr.com', 'eu.dns-cloud.net', 'eu.dnsabr.com', 'asia.dnsabr.com', '8.dnsabr.com', 'pw.8.dnsabr.com', 'mm.8.dnsabr.com', '23.8.dnsabr.com', 'pecinan.com', 'disposable-email.ml', 'pw.epac.to', 'postheo.de', 'sexy.camdvr.org', 'Disposable.ml', '888.dnS-clouD.NET', 'adult-work.info', 'casinokun.hu', 'bangsat.in', 'wallus.casinokun.hu', 'trap-mail.de', 'umailz.com', 'panchoalts.com', 'gmaile.design', 'ersatzauto.ch', 'tempes.gq', 'cpmail.life', 'tempemail.info', 'coolmailcool.com', 'kittenemail.com', '99email.xyz', 'notmyemail.tech', 'm.cloudns.cl', 'twitter-sign-in.cf', 'anonymized.org', 'you.has.dating', 'ketoblazepro.com', 'kost.party', '0hio0ak.com', '4dentalsolutions.com', 't.woeishyang.com', 'ondemandemail.top', 'kittenemail.xyz', 'blackturtle.xyz', 'y.x.ssl.cloudns.asia', 'geneseeit.com', 'mailg.ml', 'media.motornation.buzz', 'sage.speedfocus.biz', 'badlion.co.uk', 'safeemail.xyz', 'virtual-generations.com', 'new-york.host', 'mrdeeps.ml', 'kitela.work', 'fouadps.cf', 'megacorp.work', 'fake-wegwerf.email', 'tigytech.com', 'historictheology.com', 'ma.567map.xyz', 'hotmailproduct.com', 'maxsize.online', 'happyfreshdrink.com', 'denomla.com', 'pansamantala.poistaa.com', 'sahaltastari.sytes.net', 'cecep.ddnsking.com', 'fadilmalik.ddnsking.com', 'csingi.sytes.net', 'richmail.ga', 'tikmail.gq', 'bupkiss.ml', 'guerrillamail.info', 'pokemail.net', 'myinbox.icu', 'just4fun.me', 'inscriptio.in', 'cloud-mail.top', 'safemail.icu', 'montokop.pw', 'tempamailbox.info', 'blogtron.com', 'atanetorg.org', 'aristockphoto.com', 'jomcs.com', 'kukuka.org', 'gothill.com', 'mixely.com', 'marsoasis.org', 'walmarteshop.com', 'outlandlabs.com', 'comectrix.com', 'buymondo.com', 'eventao.com', 'louieliu.com', 'mymailnow.xyz', 'cuoly.com', 'getnada.com', 'abyssmail.com', 'boximail.com', 'clrmail.com', 'dropjar.com', 'getairmail.com', 'givmail.com', 'inboxbear.com', 'robot-mail.com', 'tafmail.com', 'vomoto.com', 'zetmail.com']

export const page = async () => {
    AOS.init({
        once: true,
    });
    
    formTrivia()

    //hidden errors
    // hiddenError();

    if(window.location.pathname == '/juego'){
        validateEmail(document.querySelector('#gameregisterform'), "trivia")        
    }else if(window.location.pathname == '/trivia'){
        validateEmail(document.querySelector('#triviaregisterform'), "game")
    }

}


function formTrivia(){
    var validate = new Bouncer('#triviaregisterform', {
        patterns: {
            email: /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
        },
        customValidations: {
            emailVerified: function (field: any) {
                let array_email = field.value.split("@");
                const res = emails.find(m => m === array_email[1]);
                const msnErrorCorreo = document.getElementById('edit-email--description')
                    if(msnErrorCorreo){
                        msnErrorCorreo.classList.add('hidden')
                    }
                    return res === undefined ? false : true;
                },
                
            dateFebruary : function (field:any){
                if (field.name == 'month') {
                    let inputDay = document.querySelector("#edit-day")
                    let inputMonth = document.querySelector("#edit-month")
                    const msnErrorDate = document.getElementById('edit-year--description')
                    if(msnErrorDate){
                        msnErrorDate.classList.add('hidden')
                    }
                    if(inputMonth.value == '02' || inputMonth.value == '04' || inputMonth.value == '06' || inputMonth.value == '09' || inputMonth.value == '11'){
                        if(inputDay.value == '31'){
                            return true;
                        }
                        if(inputMonth.value == '02'){
                            if(inputDay.value == '31' || inputDay.value == '30'){
                                return true;
                            }
                        }
                    }
                }                
            },

            msnAge: function(field){
                if(field.name == 'day' || field.name == 'month' || field.name == 'year'){                    
                    const msnErrorDate = document.getElementById('edit-year--description')
                    if(msnErrorDate){
                        msnErrorDate.classList.add('hidden')
                        return false
                    }
                }
            },

            phoneVerified: function (field: any) {
                if (field.name == 'phone') {
                    const value = field.value
                    const msnErrorPhone = document.getElementById('edit-phone--description')
                    if(msnErrorPhone){
                        msnErrorPhone.classList.add('hidden')
                    }else if (value.length < 7 || value.length > 10) {
                        return true;
                    }
                }
            },
            ageVerified: function(field: any) {
                if (field.name === 'birthdate_day') {
                    let year = document.getElementById('edit-birthdate-year') as any 
                    let month = document.getElementById('edit-birthdate-month') as any
                    let day = document.getElementById('edit-birthdate-day') as any
                    year = year.value;
                    month = month.value;
                    day = day.value;
                    const response = getAge(year, month, day) 
                    if (response < 18) {
                        return true;
                    }
                    document.getElementById('edit-year').classList.remove("error");
                    document.getElementById('edit-month').classList.remove("error");
                    document.getElementById('edit-day').classList.remove("error");
                    !!document.getElementById('bouncer-error_year') && document.getElementById('bouncer-error_year').remove();
                    !!document.getElementById('bouncer-error_month') && document.getElementById('bouncer-error_month').remove();
                    !!document.getElementById('bouncer-error_day') && document.getElementById('bouncer-error_day').remove();
                    return false;
                }
            }
        },
        messages: {
            missingValue: {
              checkbox: 'Debe aceptar Términos y condiciones y Aviso de privacidad',
              default: 'Campo Obligatorio'
            },
            emailVerified: 'Por favor ingrese un email válido',
            phoneVerified: 'Solo se permiten 10 digitos',
            ageVerified: 'Debe ser mayor de edad',
            dateFebruary: 'Fecha invalida',
            patternMismatch: {
                email: 'Por favor ingrese un email válido',
            },
        },
    });

    var validate1 = new Bouncer('#gameregisterform', {
        patterns: {
            email: /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
        },
        customValidations: {
            emailVerified: function (field: any) {
                let array_email = field.value.split("@");
                const res = emails.find(m => m === array_email[1]);
                const msnErrorCorreo = document.getElementById('edit-email--description')
                    if(msnErrorCorreo){
                        msnErrorCorreo.classList.add('hidden')
                    }
                return res === undefined ? false : true;
            },
            phoneVerified: function (field: any) {
                if (field.name == 'phone') {
                    const value = field.value
                    const msnErrorPhone = document.getElementById('edit-phone--description')
                    if(msnErrorPhone){
                        msnErrorPhone.classList.add('hidden')
                    }else if (value.length < 7 || value.length > 10) {
                        return true;
                    }
                }
            },
            dateFebruary : function (field:any){
                if (field.name == 'month') {
                    let inputDay = document.querySelector("#edit-day")
                    let inputMonth = document.querySelector("#edit-month")
                    const msnErrorDate = document.getElementById('edit-year--description')
                    if(msnErrorDate){
                        msnErrorDate.classList.add('hidden')
                    }
                    if(inputMonth.value == '02' || inputMonth.value == '04' || inputMonth.value == '06' || inputMonth.value == '09' || inputMonth.value == '11'){
                        if(inputDay.value == '31'){
                            return true;
                        }
                        if(inputMonth.value == '02'){
                            if(inputDay.value == '31' || inputDay.value == '30'){
                                return true;
                            }
                        }
                    }
                }                
            }, 
            msnAge: function(field){
                if(field.name == 'day' || field.name == 'month' || field.name == 'year'){                    
                    const msnErrorDate = document.getElementById('edit-year--description')
                    if(msnErrorDate){
                        msnErrorDate.classList.add('hidden')
                        return false
                    }
                }
            },
            ageVerified: function(field: any) {
                if (field.name === 'birthdate_day') {
                    let year = document.getElementById('edit-birthdate-year') as any 
                    let month = document.getElementById('edit-birthdate-month') as any
                    let day = document.getElementById('edit-birthdate-day') as any
                    year = year.value;
                    month = month.value;
                    day = day.value;
                    const response = getAge(year, month, day) 
                    if (response < 18) {
                        return true;
                    }
                    document.getElementById('edit-year').classList.remove("error");
                    document.getElementById('edit-month').classList.remove("error");
                    document.getElementById('edit-day').classList.remove("error");
                    !!document.getElementById('bouncer-error_year') && document.getElementById('bouncer-error_year').remove();
                    !!document.getElementById('bouncer-error_month') && document.getElementById('bouncer-error_month').remove();
                    !!document.getElementById('bouncer-error_day') && document.getElementById('bouncer-error_day').remove();
                    return false;
                }
            }
        },
        messages: {
            missingValue: {
              checkbox: 'Debe aceptar Términos y condiciones y Políticas de privacidad',
              default: 'Campo Obligatorio'
            },
            emailVerified: 'Por favor ingrese un email válido',
            phoneVerified: 'Solo se permiten 10 digitos',
            ageVerified: 'Debe ser mayor de edad',
            dateFebruary: 'Fecha invalida',
            patternMismatch: {
                email: 'Por favor ingrese un email válido',
            },
        },
    });

    // Detect a successful form validation
    document.addEventListener('bouncerFormValid', function (event) {
    
        // The successfully validated form
        const form = document.getElementById('triviaregisterform'),
         fieldEmail = form.querySelector('#edit-email')
        localStorage.setItem('email', fieldEmail.value);
    
    }, false);
}

function validateEmail(form:any,type:any) {
    const inputEmail:HTMLInputElement = form.querySelector('#edit-email');
        inputEmail.addEventListener("blur", function( event ) {
            // console.log(inputEmail.value);
            let dataEmail = {email: this.value,form: type}
            fetch("/read/data/"+type+"/"+inputEmail.value, {
                method: "GET",
                // body: JSON.stringify(selectmonth.value),
                headers: {
                    "Content-Type": "application/json",
                },
                // body: JSON.stringify(dataEmail)
            })
            .then(response => response.json())
            .then((json) => {
                console.log(json)
                if(json.length >= 1){
                    const name:HTMLInputElement = form.querySelector('#edit-name'),
                        lastname:HTMLInputElement = form.querySelector('#edit-lastname'),
                        phone:HTMLInputElement = form.querySelector('#edit-phone'),
                        gender:HTMLInputElement = form.querySelector('#edit-gender'),
                        day:HTMLInputElement = form.querySelector('#edit-day'),
                        month:HTMLInputElement = form.querySelector('#edit-month'),
                        year:HTMLInputElement = form.querySelector('#edit-year'),
                        state:HTMLInputElement = form.querySelector('#edit-state'),
                        postalcode:HTMLInputElement = form.querySelector('#edit-postalcode');
                        
                    let bornday = json[0].born_date.split('/')

                    name.value = json[0].name
                    lastname.value = json[0].lastname
                    phone.value = json[0].phone
                    gender.value = json[0].gender
                    state.value = json[0].state
                    postalcode.value = json[0].postalcode
                    day.value = bornday[0]
                    month.value = bornday[1]
                    year.value = bornday[2]
                }else{
                    const other = 'trivia';
                    if(type == 'trivia') other = 'game'
                    // console.log('No se encuentran coincidencias', type, other)
                    fetch("/read/data/"+other+"/"+inputEmail.value, {
                        method: "GET",
                        // body: JSON.stringify(selectmonth.value),
                        headers: {
                            "Content-Type": "application/json",
                        },
                        // body: JSON.stringify(dataEmail)
                    })
                    .then(response => response.json())
                    .then((json) => {
                        console.log(json)
                        if(json.length >= 1){
                            const name:HTMLInputElement = form.querySelector('#edit-name'),
                                lastname:HTMLInputElement = form.querySelector('#edit-lastname'),
                                phone:HTMLInputElement = form.querySelector('#edit-phone'),
                                gender:HTMLInputElement = form.querySelector('#edit-gender'),
                                day:HTMLInputElement = form.querySelector('#edit-day'),
                                month:HTMLInputElement = form.querySelector('#edit-month'),
                                year:HTMLInputElement = form.querySelector('#edit-year'),
                                state:HTMLInputElement = form.querySelector('#edit-state'),
                                postalcode:HTMLInputElement = form.querySelector('#edit-postalcode');
                                
                            let bornday1 = json[0].born_date.split('/')

                            name.value = json[0].name
                            lastname.value = json[0].lastname
                            phone.value = json[0].phone
                            gender.value = json[0].gender
                            state.value = json[0].state
                            postalcode.value = json[0].postalcode
                            day.value = bornday1[0]
                            month.value = bornday1[1]
                            year.value = bornday1[2]
                        }
                    })
                }
            })
            .catch((err: any) => {
                console.log(err)
            });
        }, true);
}

function msnAge(){
    const inputMonth = document.querySelector('#edit-month'),
        inputDay = document.querySelector("#edit-day"),
        inputYear = document.querySelector("#edit-year");
    const msnError = document.getElementById('edit-year--description')

    inputMonth && inputMonth.addEventListener('change', function(){
        if(msnError){
            msnError.classList.add('hidden')
        }
    })
    inputDay && inputDay.addEventListener('change', function(){
        if(msnError){
            msnError.classList.add('hidden')
        }
    })
    inputYear && inputYear.addEventListener('change', function(){
        if(msnError){
            msnError.classList.add('hidden')
        }
    })
}

function hiddenError() {
    const messError = document.querySelectorAll('.error');
    [...messError].forEach( e => {
        e.addEventListener('focus', x => {
            let initialValue = e.value;
            console.log(initialValue);
            
            // if(e.nextElementSibling.classList.contains('description')) {
            //     e.nextElementSibling.classList.add('hidden')
            //     e.classList.add('border')
            //     return;
            // } else if(e.nextElementSibling.classList.contains('error-message')) {
            //     setTimeout(() => {
                    
            //         e.classList.add('border2')
            //     }, 2000);
            // }
        })
    })
}
